var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "poll-text" }, [
      _vm._v(
        _vm._s(
          _vm._(
            "Всесвітня Організація Охорони Здоров'я рекомендує виключно грудне вигодовування в перші 6 місяців життя. Перед введенням прикорму проконсультуйтесь з лікарем-педіатром."
          )
        )
      )
    ]),
    _c(
      "button",
      {
        staticClass: "poll-btn poll-btn--with_ma",
        attrs: { href: "" },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.next($event)
          }
        }
      },
      [_vm._v(_vm._s(_vm._("Далі")))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bd77e0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bd77e0c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/poll/steps/moz.vue
// module id = 220
// module chunks = 4